// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"f478ef25","361":"f54cbbb6","673":"d0595053","820":"d0638d8a"}[chunkId] + ".chunk.js";
};